import { FunctionalComponent, h } from '@stencil/core';
import { AppContact } from '.';
import get from 'lodash/get'
import sortBy from 'lodash/sortBy'


interface SectionContacts {
    __component?: string;
    data?: any;
}


export const SectionContacts: FunctionalComponent<SectionContacts> = ({ data }) => {


    const { contacts, Title, Filters, Description, RemoveTopMargin } = data;
    const ContactCards = (get(contacts, 'data') || []).map(({ attributes }) => attributes);

    // Construct filter options
    const sortedFilters = Filters && Filters.data && sortBy(Filters.data, ['attributes.Group', 'attributes.Label']) || []
    const groups = sortedFilters.map(item => item.attributes.Group).filter((value, index, self) => self.indexOf(value) === index);
    const HideTitle = !Title;

    return (
        <section class={`uk-inline uk-width-1-1 uk-section ${HideTitle ? 'uk-padding-remove-top' : 'uk-margin-medium-top'} ${RemoveTopMargin ? 'uk-padding-remove-top' : 'uk-margin-medium-top'}`}>
            <div class="uk-container">
                <div class="uk-text-center" hidden={HideTitle}>
                    <h1 class="uk-heading-xlarge wsio-darker-green">
                        {Title}
                    </h1>
                    <p class="uk-container wsio-dark-grey uk-text-lead">
                        {Description}
                    </p>
                </div>
                <div class="uk-padding@s" uk-filter="target: .js-filter">
                    {
                        groups && groups.length > 0 && <div class="uk-flex-center uk-text-center uk-grid-small uk-grid-divider uk-child-width-auto" uk-grid>
                            <div>
                                <ul class="uk-subnav uk-flex-center uk-subnav-pill" uk-margin>
                                    <li class="uk-active" uk-filter-control><a href="#" rel="nofollow" >All</a></li>
                                </ul>
                            </div>
                            {
                                groups.map((group) =>
                                    <div>
                                        <ul class="uk-subnav uk-flex-center uk-subnav-pill" uk-margin>
                                            {
                                                sortedFilters
                                                    .filter(({ attributes }) => attributes.Group == group)
                                                    .map(
                                                        ({ attributes: { Label } }) => <li uk-filter-control={`filter: [data-${group}*='${Label}']; group: data-${group}`}><a href="#" rel="nofollow" >{Label}</a></li>
                                                    )
                                            }
                                        </ul>
                                    </div>
                                )
                            }
                        </div>
                    }
                    <div class="js-filter uk-margin-large-top">
                        {
                            sortBy(ContactCards,'Name').map(({ Name, JobTitle, UKTerritories, ExportTerritories, Media, Links, Tags }, i) => {
                                return <AppContact Name={Name} Role={JobTitle} Media={Media} UK={UKTerritories} Export={ExportTerritories} Links={Links} Tags={Tags} Eager={i<=3} />
                            })

                        }
                    </div>
                </div>
            </div>
        </section>
    )
};